export const checkoutUrl = (packageIds, trialInfo) => {
  const url = `/summit/checkout?package_ids=${packageIds.join(',')}`;

  if (trialInfo && trialInfo.code) {
    return `${url}&trial_code=${trialInfo.code}`;
  }

  return url;
};

export default { checkoutUrl };
